import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/element'
import '@/utils/vant'
import '@/utils/seamlessScroll'

import publicNavigation from '@/components/PC/publicNavigation.vue'
import publicFooter from '@/components/PC/publicFooter.vue'
import publicTryForFree from '@/components/PC/publicTryForFree.vue'
import mobilePublicTryForFree from '@/components/mobile/mobilePublicTryForFree.vue'
import mobilePublicNavigation from '@/components/mobile/mobilePublicNavigation.vue'
import mobilePublicFooter from '@/components/mobile/mobilePublicFooter.vue'

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.component('publicNavigation', publicNavigation)
Vue.component('publicFooter', publicFooter)
Vue.component('publicTryForFree', publicTryForFree)

Vue.component('mobilePublicNavigation', mobilePublicNavigation)
Vue.component('mobilePublicTryForFree', mobilePublicTryForFree)
Vue.component('mobilePublicFooter', mobilePublicFooter)

function setRem () {
  const isMobileDevice = window.matchMedia('(max-width: 767px)').matches
  let baseSize
  let scale

  if (window.innerWidth < 767) {
    if (!localStorage.getItem('hasReloaded')) {
      location.reload()
      localStorage.setItem('hasReloaded', 'true')
    }
  } else if (window.innerWidth >= 767) {
    if (localStorage.getItem('hasReloaded')) {
      location.reload()
      localStorage.removeItem('hasReloaded')
    }
  }
  if (!isMobileDevice) {
    baseSize = 50
    scale = document.documentElement.clientWidth / 1440
    if (scale < 1) {
      scale = Math.round(scale)
    } else if (scale >= 2) {
      scale = 1
    } else {
      scale = Math.floor(scale)
    }
  } else {
    baseSize = 37.5
    scale = 1
  }

  const size = baseSize * scale + 'px'
  document.documentElement.style.fontSize = size
}

function checkWindowWidth (list) {
  if (list.matches) {
    if (!localStorage.getItem('hasReloaded')) {
      localStorage.setItem('hasReloaded', 'true')
      location.reload()
    }
  } else if (!list.matches) {
    if (localStorage.getItem('hasReloaded')) {
      localStorage.removeItem('hasReloaded')
      location.reload()
    }
  }
  setRem()
}

const mediaQuery = window.matchMedia('(max-width: 767px)')
mediaQuery.addListener(checkWindowWidth)

checkWindowWidth(mediaQuery)
setRem()

window.addEventListener('resize', setRem)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
